import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import eventDateStrs from '../../shared/eventDateStrs';
import { State } from '../state';

interface IProps {
    id: number;
}

const Wrapper = styled.a`
    display: block;
    color: ${colors.text};
    margin: 5px 0;
    border: 1px solid ${colors.text};
    border-radius: 8px;
    &:first-child {
        margin-top: 0;
    }
    padding: 0 3vw;
    &:active, &:focus, &:hover {
        color: ${colors.text};
    }
`;

const EventLabel = styled.span`
    font-size: 0.9rem;
    font-weight: bold;
`;

const EventSubLabel = styled.span`
    font-size: 0.9rem;
`;

const EventDatetime = styled.span`
    font-size: 0.9rem;
`;

function Event({ id }: IProps): JSX.Element {
    const event = useSelector((state: State) => state.calendar.events.dict[id]);
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (event.currentTarget.getAttribute('href') === '#') {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    };

    const { startStr, endStr } = eventDateStrs(event.start, event.end);
    return <Wrapper href={event.url || '#'} onClick={handleClick}>
        <EventLabel>{event.id} {event.label}</EventLabel><br />
        {event.subLabel && <>
            <EventSubLabel>{event.subLabel}</EventSubLabel>
            <br />
        </>}
        <EventDatetime>{startStr}</EventDatetime>
        {endStr != null && <EventDatetime> - {endStr}</EventDatetime>}
    </Wrapper>;
}

export default React.memo(Event);
